import type { ToolCore, ToolModelDef } from "@loumy/contracts";
import { selectModel } from "@loumy/contracts";

// D101 Model-System (§11) — pure Logik des ModelPickers/Feld-Gatings, React-frei (testbar).
// Die SICHTBARKEIT ist reine UX: der Server strippt versteckte Felder ohnehin deterministisch
// (withModelGating im Settings-Schema) — hier wird nur gespiegelt, was er verwerfen würde.

const EMPTY: ReadonlySet<string> = new Set<string>();

/**
 * Versteckte Settings-Keys für den aktuellen Draft — `model.hiddenSettings` des gewählten
 * Modells PLUS `model` selbst (das Feld rendert der ModelPicker über dem Formular, nie die
 * generische SchemaForm — sonst erschiene das Dropdown doppelt). Tools ohne models → leer.
 */
export function hiddenSettingsFor(core: ToolCore, draft: Record<string, unknown>): ReadonlySet<string> {
  const models = core.models;
  if (!models || models.length === 0) return EMPTY;
  const model = selectModel(models, draft);
  return new Set<string>(["model", ...(model.hiddenSettings ?? [])]);
}

/**
 * Draft-Merge beim Modell-Wechsel (D101, bewusst konservativ): die `defaults` des NEUEN
 * Modells überschreiben den Draft HART (sie definieren das Modell), alle übrigen Felder
 * bleiben erhalten (User-Eingaben überleben den Wechsel; versteckte Werte strippt der
 * Server). Unbekannte id → Draft unverändert (defensiv; der Picker bietet nur echte ids an).
 */
export function applyModelSwitch(
  models: readonly ToolModelDef[],
  draft: Record<string, unknown>,
  nextModelId: string,
): Record<string, unknown> {
  const next = models.find((m) => m.id === nextModelId);
  if (!next) return draft;
  return { ...draft, ...((next.defaults as Record<string, unknown> | undefined) ?? {}), model: next.id };
}
